
import React from 'react'
import { sharedData } from '../../../models/shared_data'
import { SelectComponent } from '../../shared/select/select.component'

export class AddressSelect extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      opened: false
    }
    const c = sharedData.data.client
    if(c && c.addresses.length > 0) {
      if(!this.props.slectedId) {
        this.state.selected =  sharedData.data.client.addresses[0].id
      } else {
        this.state.selected = this.props.selectedId
      }

    }

    this.toggle = this.toggle.bind(this)
  }

  addressChanged(e) {
    const address_id = e.target.value
    this.setState({
      selected: address_id
    })
    if(!this.props.onChange)
      return
    this.props.onChange(
      sharedData.data.client.addresses.find(x => x.id == address_id)
    )
  }

  toggle(e) {
    e.preventDefault()
    this.setState({
      opened: !this.state.opened
    })
  }

  render() {
    const opts = sharedData.data.client.addresses.map((a)=> {
      return {
          id: a.id,
          title: a.full_addr
        }
    })

    return (
      <div>
        {!this.state.opened &&
          <a href='' onClick={this.toggle}>
            Выбрать из сохраненных адресов
          </a>
        }
        {this.state.opened &&
          <SelectComponent
            opts={opts}
            value={this.state.selected}
            onChange={ (e)=> { this.addressChanged(e) } }
          />
        }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/javascript/website_default/js/react/cart/make_order/address_select.component.jsx